import { render, staticRenderFns } from "./DocumentAccount.vue?vue&type=template&id=0c5a7730&scoped=true&"
import script from "./DocumentAccount.vue?vue&type=script&lang=js&"
export * from "./DocumentAccount.vue?vue&type=script&lang=js&"
import style0 from "./DocumentAccount.vue?vue&type=style&index=0&id=0c5a7730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5a7730",
  null
  
)

export default component.exports